import API from 'services/api';

export const getPaymentModels = () => {
  return API.get('/api/payment-models').then(res => res?.data);
};
